import { ComissaoStatusEnum } from "app/shared/components/enums/comissao-status.enum";

export class ComissaoResponse {
  id!: number;
  valorComissao!: number;
  dataPagamento!: Date | null;
  idUsuario!: number;
  idCliente?: number | null;
  cpfCnpjCliente?: string | null;
  nomeCliente?: string | null;
  nomeCupom?: string | null;
  idStatusComissao!: number;
  
  // Campos da imobiliária
  nomeImobiliaria?: string | null;
  cnpjImobiliaria?: string | null;
  
  // Campos do parceiro (para ADM_SISTEMA)
  nomeParceiro?: string | null;
  emailParceiro?: string | null;
  chavePix?: string | null; // cpfOuCnpj do parceiro
  
  // Comprovante
  comprovanteBase64?: string | null;

  constructor(p: any) {
    this.id = p.id ?? null;
    this.valorComissao = p.valorComissao ?? null;
    this.dataPagamento = p.dataPagamento ? new Date(p.dataPagamento) : null;
    this.idUsuario = p.idUsuario ?? null;
    this.idCliente = p.idClientePessoaFisica ?? p.idClientePessoaJuridica ?? null;
    this.cpfCnpjCliente = p.cpfClientePessoaFisica ?? p.cnpjClientePessoaJuridica ?? null;
    this.nomeCliente = p.nomeClientePessoaFisica ?? p.nomeClientePessoaJuridica ?? null;
    this.nomeCupom = p.nomeCupom ?? p.nomeCupom ?? null;
    this.idStatusComissao = p.idStatusComissao ?? null;
    
    // Imobiliária
    this.nomeImobiliaria = p.nomeImobiliaria ?? null;
    this.cnpjImobiliaria = p.cnpjImobiliaria ?? null;
    
    // Parceiro
    this.nomeParceiro = p.nomeParceiro ?? null;
    this.emailParceiro = p.emailParceiro ?? null;
    this.chavePix = p.chavePix ?? p.cpfOuCnpjParceiro ?? null;
    
    // Comprovante
    this.comprovanteBase64 = p.comprovanteBase64 ?? null;
  }

  get comissao(): string {
    return `R$ ${this.valorComissao?.toFixed(2).replace('.', ',')}`;
  }

  get data(): string {
    return this.dataPagamento?.toLocaleDateString('pt-BR') ?? '';
  }

  get status(): string {
    return ComissaoStatusEnum[this.idStatusComissao] ?? 'DESCONHECIDO';
  }
}
